<template>
  <div class="detail-container">
    <p class="paraHead" style="font-size: 26px">求助消息详情
      <Span class="paraHead">
        <Button type="text" style="font-size: 14px" @click.native="returnPage">返回之前页面</Button>
      </Span>
    </p>
    <p class="paraHead">盲人基本信息</p>
    <Card class="bodyCard">
      <Row :gutter="64">
        <Col span="3">
          <div style="width: 100px;height: 100px;background-color:#fff;">
            <img :src="helpInfo.avatarUrl" alt="headUrl" style="width: 100px;height: 100px;">
          </div>
        </Col>
        <Col span="8">
          <p class="basicInfo">
            昵称:
            <span class="content" style="color: rgba(56, 56, 56, 1);">{{helpInfo.nickname}}</span>
          </p>
          <p class="basicInfo">
            加入时间:
            <span style="float: right;">{{helpInfo.createTime}}</span>
          </p>
        </Col>
        <Col span="7">
          <p class="basicInfo">
            提问数量:
            <span style="float: right;">
              <span class="answerInfo">{{helpInfo.data.pageTotal}}</span>条
            </span>
          </p>
          <!-- <p class="basicInfo">
            提问频率:
            <span style="float: right;">
              <span class="answerInfo">3</span>条/天
            </span>
          </p>
          <p class="basicInfo">
            提问未解决:
            <span style="float: right;">
              <span class="answerInfo">5</span>条
            </span>
          </p>
        </Col>
        <Col span="7">
          <p class="basicInfo">
            被提问数量:
            <span style="float: right;">
              <span class="answerInfo">5678</span>条
            </span>
          </p>
          <p class="basicInfo">
            平均每条问题回答数:
            <span style="float: right;">
              <span class="answerInfo">4.56</span>条
            </span>
          </p> -->
        </Col>
      </Row>
      <div class="help-history">
        <img src="/static/rightArrow.png" @click="goHistory" alt>
      </div>
    </Card>
    <p class="paraHead">问题内容</p>
    <Card class="bodyCard">
      <Row :gutter="16">
        <Col span="4" v-show="helpInfo.imageUrl">
          <div style="width: 180px;height: 320px;background-color:#fff;">
            <img
              :src="helpInfo.imageUrl"
              onerror="javascript:this.src='/static/imgError.png'"
              alt="图片加载失败"
              style="width: 180px;height: 320px;"
            >
          </div>
          <Button
            type="text"
            icon="ios-download-outline"
            class="buttonStyle"
            @click.native="downPic"
          >
            <span style="font-size: 14px;">保存</span>
          </Button>
          <Button type="text" icon="ios-search-strong" class="buttonStyle" @click="picModal = true">
            <span style="font-size: 14px;">放大</span>
          </Button>
        </Col>
        <Col span="11">
          <p class="basicInfo">求助文字</p>
          <div class="innerCard">
            <Card style="box-shadow:0 5px 10px gray;">
              <p style="font-size: 16px;line-height: 20px;text-align: center">{{!helpInfo.helpText ? helpInfo.helpText : "无" }}</p>
            </Card>
          </div>
          <p class="basicInfo">求助语音</p>
          <div class="innerCard" v-show="helpInfo.voiceUrl">
            <audio controls="controls" preload="none" :src="helpInfo.voiceUrl"></audio>
          </div>
          <div class="innerCard" v-show="!helpInfo.voiceUrl">
            <Card style="box-shadow:0 5px 10px gray;height: 50px">
              <p style="font-size: 16px;line-height: 20px;text-align: center">无</p>
            </Card>
          </div>
          <p class="basicInfo">求助视频</p>
          <div class="innerCard" v-show="helpInfo.videoUrl">
            <video controls="controls" style="max-height: 300px" :src="helpInfo.videoUrl"></video>
          </div>
          <div class="innerCard" v-show="!helpInfo.videoUrl">
            <Card style="box-shadow:0 5px 10px gray;height: 50px">
              <p style="font-size: 16px;line-height: 20px;text-align: center">无</p>
            </Card>
          </div>
          <p class="basicInfo">求助进度</p>
          <div class="innerCard">
            <Progress :percent="percentNum" status="active"/>
            <Button icon="android-call" type="text" style="font-size: 20px"></Button>
            <span>客服回答:&emsp;&emsp;&emsp;无</span>
          </div>
          <p class="basicInfo">求助时间</p>
          <div class="innerCard">
            <p style="font-size: 16px">{{helpInfo.createTime}}</p>
          </div>
        </Col>
        <Col span="8">
          <div class="rightCard">
            <div style="height: 40px;background-color:rgba(42, 130, 228, 1);">
              <p class="rightHead">客服回答面板</p>
            </div>
            <p style="margin:10px">快捷选项</p>
            <Button type="primary" class="quickButton" @click.native="chooseItem(1)">{{quickItem1}}</Button>
            <Button type="primary" class="quickButton" @click.native="chooseItem(2)">{{quickItem2}}</Button>
            <Button type="primary" class="quickButton" @click.native="chooseItem(3)">{{quickItem3}}</Button>
            <Button type="primary" class="quickButton" @click.native="chooseItem(4)">{{quickItem4}}</Button>
            <hr
              style="width: 350px;height: 1px;background-color:rgba(42, 130, 228, 1);margin:10px auto;border:none"
            >
            <textarea  class="rightInnerCard" type="text" v-model="replyText"></textarea>
            <Button
              type="primary"
              class="submitButton"
              @click.native.once="successSubmit"
              :class="{'subBtn':successBtn}"
            >成功提交</Button>
          </div>
        </Col>
      </Row>
    </Card>
    <p class="paraHead">志愿者回复</p>
    <Row type="flex" justify="space-between" class="code-row-bg" style="width: 96%">
      <Col span="9" v-for="item in offerHelpInfos" :key="item.id" style="min-width:450px">
        <div class="answerBox">
          <div style="height: 30px;background-color: #2366B0">
            <p style="font-size: 14px;color:#fff;text-align: center"></p>
          </div>
          <Row class="code-row-bg" type="flex">
            <Col>
              <img :src="item.avatarUrl" class="volunteerHead" alt="头像加载失败" onerror="javascript:this.src='/static/imgError.png'">
            </Col>
            <Col>
              <p style="font-size: 14px;margin: 15px">昵称:
                <br>
                <span style="font-size: 16px">{{item.nickname}}</span>
              </p>
            </Col>
            <Col span="4" offset="5">
              <p style="font-size: 14px;color: #cccccc;margin-top:30px">详细信息</p>
            </Col>
            <Col offset="1">
              <Button
                icon="android-arrow-forward"
                class="rightBtn"
                @click.native="volunterDetailBtn2"
              ></Button>
            </Col>
          </Row>
          <hr style="height: 1px;background-color:#cccccc;border:none">
          <p class="answerList">回复内容:</p>
          <Card class="textCard">
            <p style="font-size: 16px;line-height: 20px;text-align: center">{{item.helpText}}</p>
          </Card>
          <p class="answerList">回复时间:</p>
          <p style="font-size: 16px;margin-left: 10%">{{format(item.updateTime)}}</p>
          <p style="font-size: 16px;margin-left: 10%">差值:{{diffTime(item.updateTime - item.createTime)}}</p>
          <p class="answerList" style="margin-top:20px ">此次积分</p>
          <p
            style="font-size: 16px;margin:10px;margin-left: 30%"
          >爱心积分:&emsp;&emsp;&emsp;+{{item.point}}</p>
          <p
            style="font-size: 16px;margin:10px;margin-left: 30%"
          >服务积分:&emsp;&emsp;&emsp;+{{item.gradePoint}}</p>
          <p
            style="font-size: 16px;margin:10px;margin-left: 30%"
          >时间银行:&emsp;&emsp;&emsp;+{{item.timebank}}s</p>
          <div style="display:block;margin-left: 50%">
            <Button
              icon="paintbrush"
              type="primary"
              class="changeText"
              @click.native="volunterDetailBtn2"
            ></Button>
            <span style="font-size: 14px;">修改数据</span>
          </div>
        </div>
      </Col>
    </Row>

    <Modal v-model="picModal" width="1000px" style="text-align: center"  footer-hide >
      <img :src="helpInfo.imageUrl"  style="max-width: 1000px; max-height: 670px;" alt="图片加载失败">
    </Modal>
  </div>
</template>

<script>
  import {format} from "../../utils/format.js";
  import { adminRouter } from "../../router/admin";

  export default {
    name: "helpMessageDetail",
    data() {
      return {
        helpInfo: {},                                                   //返回来的信息
        offerHelpInfos: [],                                             //志愿者回复
        nickName: "",                                                   //盲人基本信息昵称
        quesPic: "/static/avatar.jpg",
        picModal: false,                                               //图片放大弹框
        percentNum: 50,                                                 //求助进度
        quickItem: "",                                                  //提交的内容
        successBtn: false,                                              //控制按钮变色的变量
        quickItem1: "描述模糊，请尝试重新叙述问题",
        quickItem2: "图片模糊，请尝试重新拍照后提问",
        quickItem3: "视频模糊，请尝试重新拍摄后提问",
        quickItem4: "信息过多，指向不明确，请尝试重新叙述问题",
        replyText: "",                                                  //客服回复内容
        grade: [
          {
            one: 12,
            two: 3,
            three: 48
          },
          {
            one: 12,
            two: 3,
            three: 48
          },
          {
            one: 12,
            two: 3,
            three: 48
          }
        ]
      };
    },
    activated() {
      this.helpInfo = this.$route.params.helpInfo;
      this.offerHelpInfos = this.$route.params.offerHelpInfos;
    },
    mounted(){

    },
    watch:{
      helpInfo: function(res){
        this.helpInfo.createTime = format(res.createTime);
      }
    },
    methods: {
      getHelpDetail(){

      },
      returnPage() {
        /*返回到求助消息管理*/
        this.$router.go(-1);
      },
      /**
       * 查看历史求助
       */
      goHistory(){
        let active = "blindDetail";
        if (this.currentTag !== active) {
          let tags = null;
          for (let ele of adminRouter) {
            if (ele.name === active) {
              tags = {
                title: ele.title,
                name: ele.name,
                path: ele.path
              };
              break;
            } else {
              if (ele.children.length) {
                for (let val of ele.children) {
                  if (val.name === active) {
                    tags = {
                      title: val.title,
                      name: val.name,
                      path: val.path
                    };
                    break;
                  }
                }
              }
            }
          }
          localStorage.setItem("currentTag", active);
          this.$store.commit("updateCurrentTag", active);
          this.$store.commit("updateOpenedTags", [tags]);
          this.$store.commit("updateCurrentPath", active);
          this.$router.push({
            name: "blindDetail",
            query: {"id": this.helpInfo.id}
          });
        }
      },
      /**
       * 处理时间格式
       */
      format,
      diffTime(diff) {    //计算差值
        let d = Math.floor(diff/1000/60/60/24);
        let h = Math.floor((diff - d*24*60*60*1000)/1000/60/60);
        let m = Math.floor((diff - d*24*60*60*1000 - h*60*60*1000)/1000/60);
        d = d >0 ? d + "天" : "";
        h = h >0 ? h + "小时" : "";
        m = m >0 ? m + "分钟" : "";
        return d + h + m;
      },
      downloadIamge(imgsrc, name) {
        //下载图片地址和图片名
        var image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

          var a = document.createElement("a"); // 生成一个a元素
          var event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
      },
      downPic() {
        this.downloadIamge(this.helpInfo.imageUrl, "pic");
      },
      // showBig() {
      //   // this.$Modal.confirm({
      //   //   render: (h) => {}
      //   // })
      // },
      chooseItem(i) {
        switch(i){
          case 1: this.replyText = this.quickItem1; break;
          case 2: this.replyText = this.quickItem2; break;
          case 3: this.replyText = this.quickItem3; break;
          case 4: this.replyText = this.quickItem4; break;
        }
      },
      successSubmit() {
        this.successBtn = true;
        this.percentNum = 75;
        // TODO  post thequickItem
      }
    }
  };
</script>

<style scoped>
  .detail-container {
    min-width: 1100px;
  }
  .paraHead {
    font-size: 20px;
    margin-left: 25px;
    margin-top: 25px;
  }
  .bodyCard {
    background-color: #e5e5e5 !important;
    position: relative;
    margin-left: 25px;
    width: 95%;
    border-radius: 10px;
    margin-top: 10px;
  }
  .bodyCard .help-history {
    cursor: pointer;
    right: 0;
    top: 50%;
    border-radius: 50%;
    background-color: #fff;
    position: absolute;
    transform: translateX(50%) translateY(-50%);
    box-shadow: -4px 6px 2px rgba(0,0,0,0.4);
    width: 5rem;
    height: 5rem;
    transition: border 0.3s ease-out;
  }
  .bodyCard .help-history img {
    width: 3rem;
    height: 3rem;
    position: absolute;
    left: 50%;
    margin-left: -1.5rem;
    top: 50%;
    margin-top: -1.5rem;
  }
  .bodyCard .help-history:hover{
    border: 2px solid #2A82E4;
  }

  .basicInfo {
    font-size: 1.1rem;
    margin-top: 10px;
    margin-left: 20px;
  }
  .basicInfo .content {
    float: right;
    font-size: 1.1rem;
  }
  .answerInfo {
    color: rgba(42, 130, 228, 1);
  }

  .buttonStyle {
    border: 0;
    background-color: rgba(229, 229, 229, 1);
    font-size: 30px;
    display: inline-block;
    margin-bottom: -10px;
    text-align: center;
  }
  .active {
    transform: scale(1.3);
    position: absolute;
    z-index: 100;
  }
  .innerCard {
    margin-left: 50px;
    width: 300px;
  }
  .rightCard {
    box-shadow: -5px 5px 10px gray;
    margin-right: -70px;
    margin-top: -20px;
    margin-bottom: -20px;
    padding: 0;
    border-top: solid 10px rgba(42, 130, 228, 1);
    border-radius: 10px;
    background: #fff;
    height: 405px;
    text-align: center;
  }

  .rightCard .rightHead {
    font-size: 24px;
    color: #fff;
    float: right;
    margin-right: 10px;
    margin-top: 4px;
  }

  .rightCard .quickButton {
    display: block;
    margin: 10px auto;
    width: 350px;
    font-size: 15px;
    border-radius: 17px;
    background-color: #fff;
    color: rgba(42, 130, 228, 1);
  }
  .rightCard .quickButton:hover {
    background-color: rgba(42, 130, 228, 1);
    color: #fff;
  }
  .rightCard .rightInnerCard {
    width: 320px;
    margin: 0 auto;
    padding: 5px;
    box-shadow: 0 3px 10px gray;
    height: 60px;
  }

  .rightCard .submitButton {
    width: 320px;
    font-size: 16px;
    text-align: center;
    margin: 10px auto;
    display: block;
  }
  .rightCard .subBtn {
    background-color: rgb(67, 207, 124);
    border-color: rgb(67, 207, 124);
  }

  .answerBox {
    height: 547px;
    width: 100%;
    border-top: solid 10px #2366B0;
    border-bottom: solid 10px #fff;
    border-radius: 10px;
    background-color: #fff;
    margin-left: 25px;
    margin-top: 20px;
    box-shadow: 0 5px 10px gray;
  }

  .answerBox .volunteerHead {
    width: 50px;
    height: 50px;
    margin: 10px;
    border-radius: 5px;
  }

  .answerBox .rightBtn {
    margin-top: 22px;
    font-size: 18px;
    color: rgba(42, 130, 228, 1);
    background-color: #fff;
    padding: 3px 10px;
    border-radius: 20px;
    box-shadow: 3px 3px 6px gray;
  }
  .answerBox .answerList {
    font-size: 18px;
    margin: 10px;
  }
  .answerBox .textCard {
    width: 80%;
    display: block;
    margin: 0 auto;
    box-shadow: 3px 3px 6px gray;
  }
  .answerBox .changeText {
    padding: 3px 8px;
    box-shadow: 3px 3px 6px gray;
    border-radius: 20px;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// helpMessageDetail.vue?77df49ee